import * as Immutable from "immutable";
import highlightConditionFunctions from "views/logic/views/formatting/highlighting/highlightConditionFunctions";
import HighlightingColor, { StaticColor } from "views/logic/views/formatting/highlighting/HighlightingColor";
import { DEFAULT_CUSTOM_HIGHLIGHT_RANGE } from "views/Constants";
export const StringConditionLabelMap = {
  equal: "==",
  not_equal: "!="
};
export const ConditionLabelMap = {
  ...StringConditionLabelMap,
  less_equal: "<=",
  greater_equal: ">=",
  less: "<",
  greater: ">"
};
export const randomColor = () => StaticColor.create(DEFAULT_CUSTOM_HIGHLIGHT_RANGE[Math.floor(Math.random() * DEFAULT_CUSTOM_HIGHLIGHT_RANGE.length)]);
export default class HighlightingRule {
  constructor(field, value, condition, color) {
    this._value = { field, value, condition, color };
  }
  get field() {
    return this._value.field;
  }
  get value() {
    return this._value.value;
  }
  get condition() {
    var _a;
    return (_a = this._value.condition) != null ? _a : "equal";
  }
  get conditionFunc() {
    var _a;
    return highlightConditionFunctions[(_a = this._value.condition) != null ? _a : "equal"];
  }
  get color() {
    return this._value.color;
  }
  toBuilder() {
    const { field, value, condition, color } = this._value;
    return new Builder(Immutable.Map({ field, value, condition, color }));
  }
  static create(field, value, condition, color) {
    return new HighlightingRule(field, value, condition, color);
  }
  static builder() {
    return new Builder();
  }
  toJSON() {
    const { field, value, condition, color } = this._value;
    return {
      field,
      value,
      condition,
      color
    };
  }
  static fromJSON(json) {
    const { field, value, condition, color } = json;
    return HighlightingRule.create(field, value, condition, HighlightingColor.fromJSON(color));
  }
}
class Builder {
  constructor(value = Immutable.Map()) {
    this._value = value;
  }
  field(field) {
    return new Builder(this._value.set("field", field));
  }
  value(value) {
    return new Builder(this._value.set("value", value));
  }
  condition(condition) {
    return new Builder(this._value.set("condition", condition));
  }
  color(color) {
    return new Builder(this._value.set("color", color));
  }
  build() {
    const { field, value, condition, color } = this._value.toObject();
    return new HighlightingRule(field, value, condition, color);
  }
}
